export default __webpack_public_path__ + "static/media/costoco.d86bd219.svg";